import { toastr } from 'react-redux-toastr';
import { BASE_PRINT_AGENT_URL } from '../../config/endpoints';
import { numberFormatter } from '../number';
import { createPdfDocument, paragraphSize, setFont, y } from '../pdf';
import { formatTransactionDateTime } from './TotalPosSale';

// same page width Ticket.js uses ([80, 370]) for its 80mm thermal vouchers
const pageWidth = 80;
const centerX = pageWidth / 2;
const pageMargin = 5;
// keep margin on both sides of the page so long words wrap instead of
// overflowing past the printable area
const safeTextWidth = pageWidth - pageMargin * 2;
const lineHeight = 5;

const SIGNATURE_TYPE_LABELS = {
  SIN_FIRMA: 'PAGO RAPIDO, NO REQUIERE PIN NI FIRMA',
  ELECTRONICA: 'PIN VERIFICADO',
};
const DEFAULT_SIGNATURE_LABEL = 'PAGO RAPIDO, NO REQUIERE PIN NI FIRMA';
const SIGNATURE_SPACE_HEIGHT = lineHeight * 3;

const printVoidVoucher = (doc, voidResponse, isQrPayment) => {
  const {
    // transactionName,
    transactionDateTime,
    businessName,
    financialReference,
    authorizationCode,
    cardNumber,
    cardApplication,
    cardApplicationId,
    cardCryptogram,
    signature,
    amount,
  } = voidResponse;

  let myY = y + 3;

  const printCenteredLine = (text, bold = false) => {
    setFont(doc, bold ? 'bold' : 'normal');
    // splitTextToSize wraps by actual glyph width using the font just set,
    // so long words break onto new lines instead of overflowing the page
    const wrappedLines = doc.splitTextToSize(String(text), safeTextWidth);
    doc.text(wrappedLines, centerX, myY, { align: 'center' });
    myY += lineHeight * wrappedLines.length + 0.8;
  };

  doc.setFontSize(12);
  printCenteredLine('ANULACION', true);
  printCenteredLine('OPENPAY BY BBVA');
  printCenteredLine(formatTransactionDateTime(transactionDateTime));
  printCenteredLine(businessName);
  if (financialReference)
    printCenteredLine(`REF: ${String(financialReference).slice(-4)}`);
  if (authorizationCode) printCenteredLine(`APP: ${authorizationCode}`);
  if (cardNumber) printCenteredLine(`TC: ${cardNumber}`);
  // if (cardApplication) printCenteredLine(cardApplication);
  printCenteredLine(
    `TOTAL: ${numberFormatter({ value: parseFloat(amount) || 0 })}`,
  );

  if (isQrPayment) {
    printCenteredLine('PAGO CON QR');
  } else {
    if (signature === 'AUTOGRAFA') {
      myY += SIGNATURE_SPACE_HEIGHT;
      doc.line(pageMargin, myY, pageWidth - pageMargin, myY);
      myY += 5;
      printCenteredLine('FIRMA');
    } else {
      printCenteredLine(
        SIGNATURE_TYPE_LABELS[signature] || DEFAULT_SIGNATURE_LABEL,
      );
    }
    printCenteredLine(`AID: ${cardApplicationId || '.....'}`);
    printCenteredLine(`APP LABEL: ${cardApplication || '.....'}`);
    printCenteredLine(`CRYPTO : ${cardCryptogram || '.....'}`);
  }
  // printLine(doc);
  doc.setFontSize(paragraphSize);
};

function arrayBufferToBase64(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

// jsPDF forces portrait pages so height must stay >= width, or it silently
// swaps the two dimensions (matching Ticket.js's [80, 370] page, which never
// hits this because its height is always far larger than its width) —
// otherwise our 80mm-wide layout actually renders on a narrower page and
// centerX no longer lines up with the true center.
const pageHeight = 100;
const pageHeightQr = pageHeight * 0.55;

const printTotalPosVoid = async (voidResponse, isQrPayment) => {
  // open the tab synchronously, still inside the click's user-gesture
  // window — opening it after an await gets silently blocked as a popup
  const fallbackTab = window.open('', '_blank');

  // jsPDF's 'p' orientation forces height >= width and silently swaps the
  // two otherwise (see note above pageHeight) — the QR voucher is shorter
  // than it is wide, so it needs 'l' to keep [width, height] as given
  const doc = isQrPayment
    ? createPdfDocument('l', 'mm', [pageWidth, pageHeightQr])
    : createPdfDocument('p', 'mm', [pageWidth, pageHeight]);
  printVoidVoucher(doc, voidResponse, isQrPayment);
  doc.autoPrint();

  const arrayBuffer = doc.output('arraybuffer');
  const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
  const blobUrl = URL.createObjectURL(blob);
  const pdfBase64 = arrayBufferToBase64(arrayBuffer);

  try {
    await fetch(`${BASE_PRINT_AGENT_URL}/health`);
  } catch {
    if (fallbackTab) fallbackTab.location.href = blobUrl;
    toastr.error(
      'Error',
      'El agente de impresión no está corriendo. Abre print-agent.exe primero.',
    );
    return;
  }

  try {
    const response = await fetch(`${BASE_PRINT_AGENT_URL}/print`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pdfBase64, printingType: 'voucher' }),
    });

    if (!response.ok) {
      const errData = await response.json();
      throw new Error(errData.error || 'Error al imprimir');
    }

    if (fallbackTab) fallbackTab.close();
  } catch (err) {
    if (fallbackTab) fallbackTab.location.href = blobUrl;
    toastr.error('Error', err.message);
  }
};

export { printVoidVoucher };
export default printTotalPosVoid;
